import { render, staticRenderFns } from "./UnassignedCustomers.vue?vue&type=template&id=b063af00&scoped=true"
import script from "./UnassignedCustomers.vue?vue&type=script&lang=js"
export * from "./UnassignedCustomers.vue?vue&type=script&lang=js"
import style0 from "./UnassignedCustomers.vue?vue&type=style&index=0&id=b063af00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b063af00",
  null
  
)

export default component.exports